import { useTranslation } from "react-i18next";
import { ErrorPage } from "@/components/error-page/ErrorPage";

interface ConnectionLostProps {
  sectionLabel: string;
}

export const ConnectionLost = ({ sectionLabel }: ConnectionLostProps) => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      title={t("common.connection_error_title", { label: sectionLabel })}
      message={t("common.connection_error_message", {
        label: sectionLabel.toLowerCase(),
      })}
      showButton={true}
      buttonLabel={t("global.buttons.retry")}
      buttonAction={() => window.location.reload()}
    />
  );
};
